import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import InputAdornment from '@material-ui/core/InputAdornment';
import Checkbox from '@material-ui/core/Checkbox';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';

export default function AddOrEditOptionGroup__View(props) {
    const classes = useStyles();
    const [translateGui] = useGuiTranslations();
    const OkAndCancelButton = () => {
        return (
            <div className={classes.okAndCancelButtonWrapper}>
                <Button aria-label="cancel button" color="primary" variant="text" component="button" onClick={props.closeForm}>
                    {capitalizeFirstLetter(translateGui(44))}
                </Button>
                <Button aria-label="ok button" className={classes.okButton} onClick={props.submit} color="primary" variant="contained" component="button" >
                    {capitalizeFirstLetter(translateGui(45))}
                </Button>
            </div>
        )
    }


    const AllowMultiplesOfAnOption = () => {
        return (
            <div>
                <label>{capitalizeFirstLetter(translateGui(47))}</label>
                <Checkbox
                    checked={props.allowMultiplesOfAnOption}
                    value="secondary"
                    color="primary"
                    onChange={(e) => props.setAllowMultiplesOfAnOption(e.target.checked)}
                />
            </div>

        )
    }



    return (
        <div className={classes.outerWrapper}>
            <div className={classes.innerWrapper}>
                <TextField aria-label="Option group name" label={capitalizeFirstLetter(translateGui(46))} value={props.optionGroupName} onChange={(e) => props.setOptionGroupName(e.target.value)} helperText={props.optionGroupNameError} error={props.optionGroupNameError == '' ? false : true} />
                <AllowMultiplesOfAnOption></AllowMultiplesOfAnOption>
                <div>{capitalizeFirstLetter(translateGui(48))}</div>
                <div>
                    <TextField type="number" className={classes.maxWidth150} label={capitalizeFirstLetter(translateGui(49))} value={props.from} onChange={(e) => props.setFrom(e.target.value)} />
                    <span className={classes.dash}>-</span>
                    <TextField type="number" className={classes.maxWidth150} label={capitalizeFirstLetter(translateGui(50))} value={props.to} onChange={(e) => props.setTo(e.target.value)} />
                </div>
                <div style={{marginTop:'20px'}}>
                    <div>{capitalizeFirstLetter(translateGui(51))}</div>
                    {
                        props.options.map(
                            (option, index) =>
                                <div className={classes.optionRow} key={index}>
                                    <TextField key={'n_' + index} className={classes.maxWidth150} label={capitalizeFirstLetter(translateGui(53))} value={option.optionName} onChange={(e) => props.updateOption(index, 'optionName', e.target.value)} helperText={option.optionNameError} error={option.optionNameError == '' ? false : true} />
                                    <TextField key={'p_' + index} type="number" className={classes.maxWidth150} label={capitalizeFirstLetter(translateGui(27))} value={option.optionPrice} onChange={(e) => props.updateOption(index, 'optionPrice', e.target.value)}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">{props.currency}</InputAdornment>,
                                        }}
                                        helperText={option.optionPriceError} error={option.optionPriceError == '' ? false : true}
                                    />
                                    <DeleteIcon key={'d_' + index} className={classes.deleteIcon} onClick={() => props.deleteOption(index)}></DeleteIcon>
                                </div>
                        )
                    }
                    <Button aria-label="add option" className={classes.okButton} color="primary" variant="text" component="button" onClick={props.addNewOptionRow}>
                    +{capitalizeFirstLetter(translateGui(52))}
                    </Button>
                </div>
                <OkAndCancelButton></OkAndCancelButton>
            </div>
        </div>
    )


}

const useStyles = makeStyles({
    outerWrapper: {
        backgroundColor: 'rgba(142, 137, 137, 0.7)',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 101,
        overflowY: 'scroll',
        "display": "flex",
        "justifyContent": "center",
    },
    innerWrapper: {
        backgroundColor: 'white',
        minHeight: '100%',
        height: 'fit-content',
        width: '100%',
        padding: '0 10px',

        '& > *': {
            marginTop: '10px',
        }
    },
    dash: {
        margin: '0 5px',
        fontSize: '30px',
        color: 'gainsboro',
    },
    maxWidth150: {
        maxWidth: '150px',
    },
    optionRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    deleteIcon: {
        color: 'gray',
    },
    okAndCancelButtonWrapper: { "position": "fixed", "bottom": "0", "backgroundColor": "#f7f7f7", "display": "flex", "justifyContent": "flex-end", "width": "100%", "left": "0" },
    okButton: { "margin": "10px 10px" },

    '@media (min-width:600px)': {
        innerWrapper: {
            backgroundColor: 'white',
            minHeight: '300px',
            height: 'fit-content',
            width: '500px',
            marginTop: '150px',

        },
        dash: {
            margin: '0 25px',
            display: 'inline',
        },
        okAndCancelButtonWrapper: { "position": "static", },
    }
});